"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanResults = exports.ScanResult = void 0;
class ScanResult {
    constructor(obj) {
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.ScanResult = ScanResult;
class ScanResults {
    constructor(obj) {
        for (const prop in obj) {
            this[prop] = new ScanResult(obj[prop]);
        }
    }
}
exports.ScanResults = ScanResults;
//# sourceMappingURL=ScanResult.js.map